// Affichage indicatif du taux de TVA selon le pays, côté formulaire d'inscription. La source de
// vérité reste le backend (VatService) : ce qui est réellement facturé est calculé côté serveur et
// affiché sur la page Stripe. On duplique ici les taux uniquement pour informer l'utilisateur en
// direct (surtout pour les DOM-TOM). Garder aligné avec com.clickchauffeur.service.VatService.

const FRENCH_OVERSEAS_RATES = {GP: 8.5, MQ: 8.5, RE: 8.5, GF: 0, YT: 0};

const EU_STANDARD_RATES = {
  AT: 20, BE: 21, BG: 20, HR: 25, CY: 19, CZ: 21, DK: 25, EE: 22, FI: 25.5,
  DE: 19, GR: 24, HU: 27, IE: 23, IT: 22, LV: 21, LT: 21, LU: 17, MT: 18,
  NL: 21, PL: 23, PT: 23, RO: 21, SK: 23, SI: 22, ES: 21, SE: 25,
};

export function isValidEuVatNumber(vatNumber) {
  if (!vatNumber) return false;
  const v = vatNumber.replace(/\s/g, '').toUpperCase();
  return /^[A-Z]{2}[A-Z0-9]{8,12}$/.test(v);
}

// Retourne { rate: number, reverseCharge: boolean } comme le backend.
export function resolveVatRate(countryCode, vatNumber) {
  const cc = (countryCode || '').trim().toUpperCase();
  if (cc === '' || cc === 'FR') {
    return {rate: 20, reverseCharge: false};
  }
  if (Object.prototype.hasOwnProperty.call(FRENCH_OVERSEAS_RATES, cc)) {
    return {rate: FRENCH_OVERSEAS_RATES[cc], reverseCharge: false};
  }
  if (Object.prototype.hasOwnProperty.call(EU_STANDARD_RATES, cc)) {
    // Estimation prudente : on affiche toujours le taux du pays. L'autoliquidation B2B éventuelle
    // n'est accordée qu'après validation VIES côté serveur (montant définitif affiché sur Stripe).
    return {rate: EU_STANDARD_RATES[cc], reverseCharge: false};
  }
  // Hors UE : hors champ de la TVA française.
  return {rate: 0, reverseCharge: false};
}
